/**
 * "Live" header toggle — turns the live request-flow animation (particle
 * overlay) on/off. Off by default (see flowVisibilityStore): the board stays
 * calm until the user opts in. A board-chrome header item contributed by the
 * OTLP telemetry plugin, so it only appears where live telemetry is wired.
 */
import { Tooltip } from "@archlang/ui";
import { useFlowVisible, toggleFlowVisible } from "./flowVisibilityStore.js";

export function LiveToggle() {
  const on = useFlowVisible();
  return (
    <Tooltip content={on ? "Hide live request flow" : "Animate live request flow"}>
      <button
        type="button"
        onClick={() => toggleFlowVisible()}
        aria-pressed={on}
        data-live={on ? "on" : "off"}
        className={
          "inline-flex cursor-pointer items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors " +
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 " +
          (on
            ? "border-sky-400/60 bg-sky-500/15 text-sky-300 hover:bg-sky-500/25"
            : "border-slate-700 bg-slate-800/40 text-slate-500 hover:bg-slate-700/40 hover:text-slate-400")
        }
      >
        <span
          className={
            "inline-block h-1.5 w-1.5 rounded-full " +
            (on ? "bg-sky-400 animate-pulse" : "bg-slate-600")
          }
        />
        Live
      </button>
    </Tooltip>
  );
}
